import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import * as formatter from 'mt-react-common/utils/formatter';

// eslint-disable-next-line react/prefer-stateless-function
class UserFlowFundsTableItem extends Component {
  render() {
    return (
      <tr>
        <td>{formatter.dateFormat3(this.props.item.createdAt)}</td>
        <td className="text-center">
          <span
            className={this.props.item.sum < 0 ? 'text-danger' : 'text-success'}
          >
            <i
              className={
                this.props.item.sum < 0
                  ? 'fa fa-minus-circle'
                  : 'fa fa-plus-circle'
              }
            />
          </span>
        </td>
        <td>{this.props.item.typeTransactionTitle}</td>
        <td>
          <span className="text-muted">
            {this.props.item.typeTransactionComment}
          </span>
        </td>
        <td className="text-right">
          <span
            className={this.props.item.sum < 0 ? 'text-danger' : 'text-success'}
          >
            {this.props.item.sum > 0 ? '+' : ''}
            {this.props.item.sum}
          </span>
        </td>
      </tr>
    );
  }
}

UserFlowFundsTableItem.propTypes = {
  item: PropTypes.shape({
    typeTransactionTitle: PropTypes.string.isRequired,
    typeTransactionComment: PropTypes.string.isRequired,
    comment: PropTypes.string.isRequired,
    sum: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(UserFlowFundsTableItem);



// WEBPACK FOOTER //
// ./src/components/UserFlowFunds/UserFlowFundsHistoryTable/UserFlowFundsTableItem.js